import { render, staticRenderFns } from "./BarChat.vue?vue&type=template&id=07b88db8&"
import script from "./BarChat.vue?vue&type=script&lang=js&"
export * from "./BarChat.vue?vue&type=script&lang=js&"
import style0 from "./BarChat.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports